import { render, staticRenderFns } from "./TheRecoverAccountView.vue?vue&type=template&id=0905e883&scoped=true"
import script from "./TheRecoverAccountView.vue?vue&type=script&lang=js"
export * from "./TheRecoverAccountView.vue?vue&type=script&lang=js"
import style0 from "./TheRecoverAccountView.vue?vue&type=style&index=0&id=0905e883&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0905e883",
  null
  
)

export default component.exports